import { render, staticRenderFns } from "./YcPaginationCustom.vue?vue&type=template&id=7b37ca34&scoped=true&lang=pug&"
import script from "./YcPaginationCustom.vue?vue&type=script&lang=js&"
export * from "./YcPaginationCustom.vue?vue&type=script&lang=js&"
import style0 from "./YcPaginationCustom.vue?vue&type=style&index=0&id=7b37ca34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37ca34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSelect,VSpacer})
